<template>
  <div>
    <nuxt-img
      v-if="src"
      :src="src"
      :alt="altText || 'Card image'"
      :width="parsedSize.width"
      :height="parsedSize.height"
      preset="card-image"
      provider="shopify"
    />
    <slot name="discount-pill" />
    <slot />
  </div>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => ({})
    },
    src: { type: String, default: '' },
    altText: { type: String, default: '' },
    size: { type: String, default: "250x250" },
  },
  computed: {
    parsedSize() {
      const size = this.size
      const [ width, height ] = (size || "250x250").split('x')
      return { width, height }
    }
  },
}
</script>
